import React, { createContext, useMemo } from 'react'
import { getCellValue } from '../../board/utils';
import { firstValid } from '../../utils';
import { asBool } from '../input/utils';
import ListData from './listdata';
import { colTyped } from '../../board/table/parsecolumns';
import { useMultiOptionList } from '../input/useoptionlist';

export const listPathId = path => (path || "").replace(/([._-]+)/g, '')

export const OptionListContext = createContext([])

const previewLoaderFactory = (struct = [], pageData = {}, optionList = []) => {
	let filtered = struct.filter(e => asBool(e.preview));
	if (!filtered.length) filtered = struct.filter(e => !e.hideonform && e.type !== "list").slice(0, 3); //first three

	return item => filtered.map(field => {
		const value = getCellValue(item, (field.path || field.name))

		if (field.formatter instanceof Function)
			return field.formatter(item.currency).format(value)

		const idx = struct.indexOf(field)
		return colTyped(field, item, pageData, optionList[idx]);
	}).join(" - ");
}

const List = ({ struct = [], data: formData, dispatch, path, ...props }) => {
	const data = firstValid(formData, []);
	const optionList = useMultiOptionList({ fields: struct })
	const listData = ((data instanceof Array) ? data : [data])
	if (!path && listData.length > 1) throw Error("Se espera sólo un elmento en [data] o un [path]");

	const childCount = listData.filter(e => e).length

	const itemPreview = useMemo(() => previewLoaderFactory(struct, props.pageData, optionList), [props.pageData, optionList, struct])

	const removeItem = (idx) => {
		const newdata = [...listData];
		newdata.splice(idx, 1)
		dispatch({ type: "set-value", path: path, payload: newdata })
	}

	return (
		<OptionListContext.Provider value={optionList}>
			{
				listData.map((elm, idx) => elm && <ListData key={idx} idx={idx} elm={elm} childCount={childCount} struct={struct} path={path} removeItem={removeItem} itemPreview={itemPreview} dispatch={dispatch} {...props} />)
			}
		</OptionListContext.Provider>
	)
}

export default List;
